import { call, put, takeEvery } from 'redux-saga/effects'
import {
  // pharmacy admin
  getSubProductTypeListData,
  getSubProductTypeListSuccess,
  getSubProductTypeListFailed,
  addSubProductTypeListDataSuccess,
  addSubProductTypeListDataFailed,
  addSubProductTypeListData,
  getWearableSizesListApiData,
  getWearableSizesListApiDataSuccess,
  getWearableSizesListApiDataFailed,
  getProductTypeListApiDataSuccess,
  getProductTypeListApiDataFailed,
  getProductTypeListApiData,
  getDrugCompositionListApiData,
  getDrugCompositionListApiDataSuccess,
  getDrugCompositionListApiDataFailed,
  // Add drug Compositions
  addDrugCompositionApiData,
  addDrugCompositionApiDataSuccess,
  addDrugCompositionApiDataFailed,

  // Update Sub type product Type
  updateSubTypeProductData,
  updateSubTypeProductDataSuccess,
  updateSubTypeProductDataFailed,
  // update drug composition
  updateDrugCompositionDataSuccess,
  updateDrugCompositionDataFailed,
  updateDrugCompositionData,
  // delete drug Compositions
  deleteDrugCompositionsDataSuccess,
  deleteDrugCompositionsDataFailed,
  deleteDrugCompositionsData,
  // get List Complaint Data
  getListComplaintCategoriesData,
  getListComplaintCategoriesDataSuccess,
  getListComplaintCategoriesDataFailed,
  //get list Suggestain Data
  getListSuggestionsCategoriesData,
  getListSuggestionsCategoriesDataSuccess,
  getListSuggestionsCategoriesDataFailed,
  // get product List Category
  getListProductCategoryData,
  getListProductCategoryDataSuccess,
  getListProductCategoryDataFailed,
  // add product Category
  addProductCategoryData,
  addProductCategoryDataSuccess,
  addProductCategoryDataFailed,
  // update product Category data
  updateProductCategoryData,
  updateProductCategoryDataSuccess,
  updateProductCategoryDataFailed,
  // delete product Category data
  deleteProductCategoryData,
  deleteProductCategoryDataSuccess,
  deleteProductCategoryDataFailed,
  // delete product sub type category data
  deleteProductSubTypeData,
  deleteProductSubTypeDataSuccess,
  deleteProductSubTypeDataFailed,
  // Add product data
  addProductData,
  addProductDataSuccess,
  addProductDataFailed,
  // get product Data
  getListProductDataSuccess,
  getListProductData,
  getListProductDataFailed,
  // list Product details
  getListProductDetailsData,
  getListProductDetailsDataFailed,
  getListProductDetailsDataSuccess,

  // get Order Medicine
  getOrderPharmacyListApiData,
  getOrderPharmacyListDataSuccess,
  getOrderPharmacyListDataFailed,

  //  Each Order PharmacyListData
  getEachPharmacyOrderListData,
  getEachPharmacyOrderListDataSuccess,
  getEachPharmacyOrderListDataFailed,
  // get product Details
  getProductDeatilsApiData,
  getProductDeatilsDataSuccess,
  getProductDeatilsFailed,

  // get Pharmacy Details
  getPharmacyDetailsListApiData,
  getPharmacyDetailsListApiSuccess,
  getPharmacyDetailsListApiFailed,

  // Add product Type
  addProductTypeListListApiSuccess,
  addProductTypeListListApiFailed,
  addProductTypeListListApiData,
  // update product Type
  updateProductTypeListApiSuccess,
  updateProductTypeListApiFailed,
  updateProductTypeListApiData,
  // delete Product type
  deleteProductTypeListApiSuccess,
  deleteProductTypeListApiFailed,
  deleteProductTypeListApiData,
  // getProduct Type Details
  getProductTypeDetailsApiData,
  getProductTypeDetailsApiSuccess,
  getProductTypeDetailsApiFailed,

  // get Product Category details
  getProductCategoryDetailsApiData,
  getProductCategoryDetailsApiSuccess,
  getProductCategoryDetailsApiFailed,

  // get Sub Category Details
  getProductSubCategoryDetailsApiData,
  getProductSubCategoryDetailsApiSuccess,
  getProductSubCategoryDetailsFailed,

  // add Product By Excel
  addProductByExcelApiData,
  addProductByExcelApiSucees,
  addProductByExcelApiFailed,

  // get All Product List
  getallProductListApiData,
  getallProductListApiSucees,
  getallProductListApiFailed,
  // Update product Details
  updateProductApiData,
  updateProductSucees,
  updateProductFailed,

  // product Details Change Status
  productStatusChangeApiData,
  productStatusChangeApiSucees,
  productStatusChangeApiFailed,

  //  Add Medicine Product
  addMedicineProductData,
  addMedicineProductApiSuccess,
  addMedicineProductApiFailed,

  // getMedicineProductList
  getMedicineProductListData,
  getMedicineProductListApiSuccess,
  getMedicineProductListApiFailed,

  // getMedicineDetails
  getMedicineDetailsData,
  getMedicineDetailsApiSucees,
  getMedicineDetailsApiFailed,

  // Add Pharmacy By Excel through Admin
  addPharmacyByExcelApiData,
  addPharmacyByExcelApiSucees,
  addPharmacyByExcelApiFailed,
} from './slice'
import { API } from '../../services'

//Pharmacy Admin

function* getSubProductTypeList({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.subProductTypeListApi, payload)
    if (response.data && response.status === 200) {
      yield put(getSubProductTypeListSuccess({ payload: response?.data }))
    } else {
      yield put(getSubProductTypeListFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getSubProductTypeListFailed({ message: error?.message }))
  }
}
function* addSubProductTypeDataApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.addPharmacySubType, payload)
    if (response.data && response.status === 200) {
      yield put(addSubProductTypeListDataSuccess({ payload: response?.data }))
    } else {
      yield put(addSubProductTypeListDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addSubProductTypeListDataFailed({ message: error?.message }))
  }
}
function* getWearableSizesListApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.getWearableSizesListApi, payload)
    if (response.data && response.status === 200) {
      yield put(getWearableSizesListApiDataSuccess({ payload: response?.data }))
    } else {
      yield put(getWearableSizesListApiDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getWearableSizesListApiDataFailed({ message: error?.message }))
  }
}
function* getProductListTypeApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.getProductTypeList, payload)
    if (response.data && response.status === 200) {
      yield put(getProductTypeListApiDataSuccess({ payload: response?.data }))
    } else {
      yield put(getProductTypeListApiDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getProductTypeListApiDataFailed({ message: error?.message }))
  }
}
function* getDrugCompositionListApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.getDrugCompositionList, payload)
    if (response.data && response.status === 200) {
      yield put(getDrugCompositionListApiDataSuccess({ payload: response?.data }))
    } else {
      yield put(getDrugCompositionListApiDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getDrugCompositionListApiDataFailed({ message: error?.message }))
  }
}
function* AddDrugCompositionApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.addDrugComposition, payload)
    if (response.data && response.status === 200) {
      yield put(addDrugCompositionApiDataSuccess({ payload: response?.data }))
    } else {
      yield put(addDrugCompositionApiDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addDrugCompositionApiDataFailed({ message: error?.message }))
  }
}
function* updateSubTypeProductDataApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.updateSubTypeProductData, payload)
    if (response.data && response.status === 200) {
      yield put(updateSubTypeProductDataSuccess({ payload: response?.data }))
    } else {
      yield put(updateSubTypeProductDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateSubTypeProductDataFailed({ message: error?.message }))
  }
}
function* updateDrugCompositionDataApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.updateDrugComposition, payload)
    if (response.data && response.status === 200) {
      yield put(updateDrugCompositionDataSuccess({ payload: response?.data }))
    } else {
      yield put(updateDrugCompositionDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateDrugCompositionDataFailed({ message: error?.message }))
  }
}
function* deleteDrugCompositionsDataApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.deleteDrugCompositions, payload)
    if (response.data && response.status === 200) {
      yield put(deleteDrugCompositionsDataSuccess({ payload: response?.data }))
    } else {
      yield put(deleteDrugCompositionsDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteDrugCompositionsDataFailed({ message: error?.message }))
  }
}
function* getListComplaintCategoriesDataApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.getListComplaintCategoriesData, payload)
    if (response.data && response.status === 200) {
      yield put(getListComplaintCategoriesDataSuccess({ payload: response?.data }))
    } else {
      yield put(getListComplaintCategoriesDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getListComplaintCategoriesDataFailed({ message: error?.message }))
  }
}

function* getListSuggestionsCategoriesDataApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.getListSuggestionsCategoriesData, payload)
    if (response.data && response.status === 200) {
      yield put(getListSuggestionsCategoriesDataSuccess({ payload: response?.data }))
    } else {
      yield put(getListSuggestionsCategoriesDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getListSuggestionsCategoriesDataFailed({ message: error?.message }))
  }
}
function* getListProductCategoryDataApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.getListProductCategoryData, payload)
    if (response.data && response.status === 200) {
      yield put(getListProductCategoryDataSuccess({ payload: response?.data }))
    } else {
      yield put(getListProductCategoryDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getListProductCategoryDataFailed({ message: error?.message }))
  }
}
function* addProductCategoryDataApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.addProductCategoryData, payload)
    if (response.data && response.status === 200) {
      yield put(addProductCategoryDataSuccess({ payload: response?.data }))
    } else {
      yield put(addProductCategoryDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addProductCategoryDataFailed({ message: error?.message }))
  }
}
function* updateProductCategoryDataApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.updateProductCategoryData, payload)
    if (response.data && response.status === 200) {
      yield put(updateProductCategoryDataSuccess({ payload: response?.data }))
    } else {
      yield put(updateProductCategoryDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateProductCategoryDataFailed({ message: error?.message }))
  }
}
function* deleteProductCategoryDataApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.deleteProductCategoryData, payload)
    if (response.data && response.status === 200) {
      yield put(deleteProductCategoryDataSuccess({ payload: response?.data }))
    } else {
      yield put(deleteProductCategoryDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteProductCategoryDataFailed({ message: error?.message }))
  }
}
function* deleteProductSubTypeApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.deleteProductSubType, payload)
    if (response.data && response.status === 200) {
      yield put(deleteProductSubTypeDataSuccess({ payload: response?.data }))
    } else {
      yield put(deleteProductSubTypeDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteProductSubTypeDataFailed({ message: error?.message }))
  }
}
function* addProductApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.addProduct, payload)
    if (response.data && response.status === 200) {
      yield put(addProductDataSuccess({ payload: response?.data }))
    } else {
      yield put(addProductDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addProductDataFailed({ message: error?.message }))
  }
}
function* getListProductApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.getListProduct, payload)
    if (response.data && response.status === 200) {
      yield put(getListProductDataSuccess({ payload: response?.data }))
    } else {
      yield put(getListProductDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getListProductDataFailed({ message: error?.message }))
  }
}
function* getListProductDetailsApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.getListProductDetails, payload)
    if (response.data && response.status === 200) {
      yield put(getListProductDetailsDataSuccess({ payload: response?.data }))
    } else {
      yield put(getListProductDetailsDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getListProductDetailsDataFailed({ message: error?.message }))
  }
}
function* getOrderPharmacyListApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.getOrderPharmacyList, payload)
    if (response.data && response.status === 200) {
      yield put(getOrderPharmacyListDataSuccess({ payload: response?.data }))
    } else {
      yield put(getOrderPharmacyListDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getOrderPharmacyListDataFailed({ message: error?.message }))
  }
}
function* getEachOrderPharmacyListApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.getEachPharmacyOrderList, payload)
    if (response.data && response.status === 200) {
      yield put(getEachPharmacyOrderListDataSuccess({ payload: response?.data }))
    } else {
      yield put(getEachPharmacyOrderListDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getEachPharmacyOrderListDataFailed({ message: error?.message }))
  }
}
function* getProductDeatilsApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.getProductDeatils, payload)
    if (response.data && response.status === 200) {
      yield put(getProductDeatilsDataSuccess({ payload: response?.data }))
    } else {
      yield put(getProductDeatilsFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getProductDeatilsFailed({ message: error?.message }))
  }
}
function* getPharmacyDetailsListApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.getPharmacyDetailsList, payload)
    if (response.data && response.status === 200) {
      yield put(getPharmacyDetailsListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getPharmacyDetailsListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getPharmacyDetailsListApiFailed({ message: error?.message }))
  }
}
function* addProductTypeListApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.addProductTypeList, payload)
    if (response.data && response.status === 200) {
      yield put(addProductTypeListListApiSuccess({ payload: response?.data }))
    } else {
      yield put(addProductTypeListListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addProductTypeListListApiFailed({ message: error?.message }))
  }
}
function* updateProductTypeListApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.updateProductTypeList, payload)
    if (response.data && response.status === 200) {
      yield put(updateProductTypeListApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateProductTypeListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateProductTypeListApiFailed({ message: error?.message }))
  }
}
function* deleteProductTypeListApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.deleteProductTypeList, payload)
    if (response.data && response.status === 200) {
      yield put(deleteProductTypeListApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteProductTypeListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteProductTypeListApiFailed({ message: error?.message }))
  }
}
function* getProductTypeDetailsApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.getProductTypeDetails, payload)
    if (response.data && response.status === 200) {
      yield put(getProductTypeDetailsApiSuccess({ payload: response?.data }))
    } else {
      yield put(getProductTypeDetailsApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getProductTypeDetailsApiFailed({ message: error?.message }))
  }
}
function* getProductCategoryDetailsApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.getProductCategoryDetails, payload)
    if (response.data && response.status === 200) {
      yield put(getProductCategoryDetailsApiSuccess({ payload: response?.data }))
    } else {
      yield put(getProductCategoryDetailsApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getProductCategoryDetailsApiFailed({ message: error?.message }))
  }
}
function* getProductSubCategoryDetailsApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.getProductSubCategoryDetails, payload)
    if (response.data && response.status === 200) {
      yield put(getProductSubCategoryDetailsApiSuccess({ payload: response?.data }))
    } else {
      yield put(getProductSubCategoryDetailsFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getProductSubCategoryDetailsFailed({ message: error?.message }))
  }
}
function* addProductByExcelApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.addProductByExcel, payload)
    if (response.data && response.status === 200) {
      yield put(addProductByExcelApiSucees({ payload: response?.data }))
    } else {
      yield put(addProductByExcelApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addProductByExcelApiFailed({ message: error?.message }))
  }
}
function* addPharmacyByExcelApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.addPharmacyByExcel, payload)
    if (response.data && response.status === 200) {
      yield put(addPharmacyByExcelApiSucees({ payload: response?.data }))
    } else {
      yield put(addPharmacyByExcelApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addPharmacyByExcelApiFailed({ message: error?.message }))
  }
}
function* getallProductListApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.getallProductList, payload)
    if (response.data && response.status === 200) {
      yield put(getallProductListApiSucees({ payload: response?.data }))
    } else {
      yield put(getallProductListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getallProductListApiFailed({ message: error?.message }))
  }
}
function* updateProductApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.updateProduct, payload)
    if (response.data && response.status === 200) {
      yield put(updateProductSucees({ payload: response?.data }))
    } else {
      yield put(updateProductFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateProductFailed({ message: error?.message }))
  }
}
function* productStatusChangeApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.productStatusChange, payload)
    if (response.data && response.status === 200) {
      yield put(productStatusChangeApiSucees({ payload: response?.data }))
    } else {
      yield put(productStatusChangeApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(productStatusChangeApiFailed({ message: error?.message }))
  }
}
function* addMedicineProductApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.addMedicineProduct, payload)
    if (response.data && response.status === 200) {
      yield put(addMedicineProductApiSuccess({ payload: response?.data }))
    } else {
      yield put(addMedicineProductApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addMedicineProductApiFailed({ message: error?.message }))
  }
}
function* getMedicineProductListApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.getListMedicineData, payload)
    if (response.data && response.status === 200) {
      yield put(getMedicineProductListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getMedicineProductListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getMedicineProductListApiFailed({ message: error?.message }))
  }
}
function* getMedicineDetailsApi({ type, payload }) {
  try {
    const response = yield call(API.ManagePharmacy.getMedicineDetails, payload)
    if (response.data && response.status === 200) {
      yield put(getMedicineDetailsApiSucees({ payload: response?.data }))
    } else {
      yield put(getMedicineDetailsApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getMedicineDetailsApiFailed({ message: error?.message }))
  }
}

function* settingSaga() {
  //pharmacy admin
  yield takeEvery(getSubProductTypeListData, getSubProductTypeList)
  yield takeEvery(addSubProductTypeListData, addSubProductTypeDataApi)
  yield takeEvery(getWearableSizesListApiData, getWearableSizesListApi)
  yield takeEvery(getProductTypeListApiData, getProductListTypeApi)
  yield takeEvery(getDrugCompositionListApiData, getDrugCompositionListApi)
  yield takeEvery(addDrugCompositionApiData, AddDrugCompositionApi)
  yield takeEvery(updateSubTypeProductData, updateSubTypeProductDataApi)
  yield takeEvery(updateDrugCompositionData, updateDrugCompositionDataApi)
  yield takeEvery(deleteDrugCompositionsData, deleteDrugCompositionsDataApi)
  yield takeEvery(getListComplaintCategoriesData, getListComplaintCategoriesDataApi)
  yield takeEvery(getListSuggestionsCategoriesData, getListSuggestionsCategoriesDataApi)
  yield takeEvery(getListProductCategoryData, getListProductCategoryDataApi)
  yield takeEvery(addProductCategoryData, addProductCategoryDataApi)
  yield takeEvery(updateProductCategoryData, updateProductCategoryDataApi)
  yield takeEvery(deleteProductCategoryData, deleteProductCategoryDataApi)
  yield takeEvery(deleteProductSubTypeData, deleteProductSubTypeApi)
  yield takeEvery(addProductData, addProductApi)
  yield takeEvery(getListProductData, getListProductApi)
  yield takeEvery(getListProductDetailsData, getListProductDetailsApi)
  yield takeEvery(getOrderPharmacyListApiData, getOrderPharmacyListApi)
  yield takeEvery(getEachPharmacyOrderListData, getEachOrderPharmacyListApi)
  yield takeEvery(getProductDeatilsApiData, getProductDeatilsApi)
  yield takeEvery(getPharmacyDetailsListApiData, getPharmacyDetailsListApi)
  yield takeEvery(addProductTypeListListApiData, addProductTypeListApi)
  yield takeEvery(updateProductTypeListApiData, updateProductTypeListApi)
  yield takeEvery(deleteProductTypeListApiData, deleteProductTypeListApi)
  yield takeEvery(getProductTypeDetailsApiData, getProductTypeDetailsApi)
  yield takeEvery(getProductCategoryDetailsApiData, getProductCategoryDetailsApi)
  yield takeEvery(getProductSubCategoryDetailsApiData, getProductSubCategoryDetailsApi)
  yield takeEvery(addProductByExcelApiData, addProductByExcelApi)
  yield takeEvery(addPharmacyByExcelApiData, addPharmacyByExcelApi)
  yield takeEvery(getallProductListApiData, getallProductListApi)
  yield takeEvery(updateProductApiData, updateProductApi)
  yield takeEvery(productStatusChangeApiData, productStatusChangeApi)
  yield takeEvery(addMedicineProductData, addMedicineProductApi)
  yield takeEvery(getMedicineProductListData, getMedicineProductListApi)
  yield takeEvery(getMedicineDetailsData, getMedicineDetailsApi)
}

export default settingSaga
